module.exports = __webpack_public_path__ + "static/media/driver-behaviour.9bd4a55d.svg";